import React from 'react'
import {
    Inject,
    ChartComponent,
    SeriesCollectionDirective,
    SeriesDirective,
    Tooltip,
    Category,
    DataLabel,
    Legend,
    SplineSeries,
} from '@syncfusion/ej2-react-charts';

  import "../Tables/Customs/syncfusion-grid-overrides.css";
  import "@syncfusion/ej2-base/styles/bootstrap5.css";
  import "@syncfusion/ej2-buttons/styles/bootstrap5.css";
  import "@syncfusion/ej2-inputs/styles/bootstrap5.css";
  import "@syncfusion/ej2-navigations/styles/bootstrap5.css";
  import "@syncfusion/ej2-popups/styles/bootstrap5.css";
  import "@syncfusion/ej2-splitbuttons/styles/bootstrap5.css";
  import "@syncfusion/ej2-dropdowns/styles/bootstrap5.css";
  import "@syncfusion/ej2-grids/styles/bootstrap5.css";
  import "../../../styles/chartResponsive.css";

import { useTheme } from '../../../contexts/ThemeContext';

export const ChartLineColumns = (props) => {
  const { isDark } = useTheme();

  return (
    <div className="chart-container chart-line-container">
      <ChartComponent
        id={props.id}
        height={'100%'}
        width={'100%'}
        chartArea={{ border: { width: 0 } }}
        margin={{ left: 0, right: 0, top: 0, bottom: 40 }}
        primaryXAxis={{
          valueType: "Category",
          title: "",
          titleStyle: { color: isDark ? "#ffffff" : "#000000" },
          labelStyle: { color: isDark ? "#ffffff" : "#000000" }
        }}
        primaryYAxis={{
          titleStyle: { color: isDark ? "#ffffff" : "#000000" },
          labelStyle: { color: isDark ? "#ffffff" : "#000000" },
          labelFormat: '{value} km'
        }}
        tooltip={{ enable: true }}
        legendSettings={{
          visible: true,
          position: "Bottom",
          alignment: "Start",
          textStyle: { color: isDark ? "#ffffff" : "#000000" }
        }}
        style={{ width: '100%', height: '100%', minHeight: '300px' }}
      >
        <Inject services={[SplineSeries, Category, Tooltip, Legend, DataLabel]} />

        <SeriesCollectionDirective>
          {/* Semana 1 */}
          <SeriesDirective
            type="Spline"
            dataSource={props.data}
            xName="dayName"
            yName="week0"
            name="Semana atual"
            width={3}
            marker={{
              visible: true,
              dataLabel: {
                visible: true,
                position: "Top",
                font: { color: isDark ? "#ffffff" : "#000000", size: "12px" }
              }
            }}
            fill={props.fill1 || "#f28b82"}
          />
          {/* Semana 2 */}
          <SeriesDirective
            type="Spline"
            dataSource={props.data}
            xName="dayName"
            yName="week1"
            name="Semana - 1"
            width={3}
            marker={{
              visible: true,
              dataLabel: {
                visible: true,
                position: "Top",
                font: { color: isDark ? "#ffffff" : "#000000", size: "12px" }
              }
            }}
            fill={props.fill2 || "#26c6da"}
          />
          {/* Semana 3 */}
          <SeriesDirective
            type="Spline"
            dataSource={props.data}
            xName="dayName"
            yName="week2"
            name="Semana - 2"
            width={3}
            marker={{
              visible: true,
              dataLabel: {
                visible: true,
                position: "Top",
                font: { color: isDark ? "#ffffff" : "#000000", size: "12px" }
              }
            }}
            fill={props.fill3 || "#8b8bf9"}
          />

          {/* Semana 4 */}
          <SeriesDirective
            type="Spline"
            dataSource={props.data}
            xName="dayName"
            yName="week3"
            name="Semana - 3"
            width={3}
            marker={{
              visible: true,
              dataLabel: {
                visible: true,
                position: "Top",
                font: { color: isDark ? "#ffffff" : "#000000", size: "12px" }
              }
            }}
            fill={props.fill4 || "#8b8bf9"}
          />
        </SeriesCollectionDirective>
      </ChartComponent>
    </div>
  )
}
